export const ENTERPRISE_INCLUDED_ACTIVE_LOCATIONS = 10;
export const ENTERPRISE_ACTIVE_LOCATION_PRICE_CENTS = 5000;

export const ENTERPRISE_CONTACT_HREF =
  "/contact?source=pricing&plan=enterprise&type=enterprise";

